module.exports = __webpack_public_path__ + "static/media/Michael-Kerr-Resume.13950c5b.pdf";